import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customReason", "submit"];

  update() {
    const reason = this.element.querySelector("input:checked")?.value;
    const submit = this.element.querySelector("input[type='submit']");
    const customReasonInput = this.customReasonTarget.querySelector("input");

    if (reason === "other") {
      this.customReasonTarget.classList.remove("hidden");
      customReasonInput.disabled = false;
    } else {
      this.customReasonTarget.classList.add("hidden");
      customReasonInput.disabled = true;
    }

    const customReason = customReasonInput.value;

    submit.disabled = !((reason && reason !== "other") || customReason);
  }
}
